<template>
    <div>
        <form-emergency-plan/>
        <form-client-emergency :disabled="true"/>
    </div>
</template>

<script>
import {mapState} from "vuex"
import {createHelpers} from "vuex-map-fields"
import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es'
import formEmergencyPlan from "@/views/gei/children_installations/form/tabEmergency/components/formEmergencyPlan"
import formClientEmergency
    from "@/views/gei/masters_installations/form/generalDataAndRisks/components/formClientEmergency"

const {mapFields} = createHelpers({
    getterType: 'masterInstallationDocuments/getField',
    mutationType: 'masterInstallationDocuments/updateField',
})

export default {
    name: "FormGeneralDataAndRisksView",
    components: {
        formEmergencyPlan,
        formClientEmergency
    },
    data() {
        return {
            SpanishLocale,
            edit: false,
            showLoading: false,
        }
    },
    computed: {
        ...mapState('masterInstallationDocuments', []),
        ...mapFields({

        }),
    },
    created() {

    },
    methods: {
        can(permission) {
            return this.$store.getters.can(permission)
        },
    }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>